import * as React from "react";
import logoBigHeardsmallFree from './images/logoBigHeardsmallFree.png';
function SvgBigIcon(props) {
  return (
    <img src={logoBigHeardsmallFree} width={72} height={71} {...props} alt="fireHeard" /> 
  );
}

export default SvgBigIcon